const IAM_SCOPES = [
  'openid',
  'profile',
  'read:permissions',
  // You can add more scopes (granted services) here
  'catalog',
];

export default {
  IAM_SCOPES,
  ALL: 'all',
  TABLET_WIDTH: 768,
};
